"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEADER_FOOTER_RECALC_TRIGGER = void 0;
require("@services/quill-matcher-service");
var feature_flipper_1 = require("@shared/constants/feature-flipper");
var environment_1 = require("@shared/types/environment");
var angular_1 = __importDefault(require("angular"));
var HEADER_FOOTER_RECALC_TRIGGER;
(function (HEADER_FOOTER_RECALC_TRIGGER) {
    HEADER_FOOTER_RECALC_TRIGGER["filters"] = "filtersChanged";
    HEADER_FOOTER_RECALC_TRIGGER["participantChange"] = "ParticipantChange";
    HEADER_FOOTER_RECALC_TRIGGER["headerFooterRendered"] = "pageHeaderOrFooterIsRendered";
    HEADER_FOOTER_RECALC_TRIGGER["privateExportEnvSet"] = "privateExportEnvSet";
})(HEADER_FOOTER_RECALC_TRIGGER = exports.HEADER_FOOTER_RECALC_TRIGGER || (exports.HEADER_FOOTER_RECALC_TRIGGER = {}));
(function (angularModule) {
    angularModule.factory('prHeaderFooterInitService', [
        '$q',
        'prHeaderFooterService',
        'prPageHeaderFooterOptionsService',
        'prPipedTextDynamicValueService',
        'prPageHeaderFooterGenerator',
        'prEventService',
        'pr.WIDGET_MANAGER_EVENTS',
        'rsEnvironment',
        'pr.EVENTS',
        'pr.quillMatcher',
        function (
        // @ts-ignore
        $q, 
        // @ts-ignore
        headerFooterService, 
        // @ts-ignore
        headerFooterOptionsService, 
        // @ts-ignore
        DynamicValueService, 
        // @ts-ignore
        pageHeaderFooterGenerator, 
        // @ts-ignore
        eventService, WIDGET_MANAGER_EVENTS, env, 
        // @ts-ignore
        EVENTS, 
        // @ts-ignore
        quillMatcher) {
            var HEADER = 'header';
            var FOOTER = 'footer';
            var dynamicValue = new DynamicValueService();
            eventService.on(HEADER_FOOTER_RECALC_TRIGGER.participantChange, recalculatePipedText);
            eventService.on(HEADER_FOOTER_RECALC_TRIGGER.filters, recalculatePipedText);
            eventService.on(HEADER_FOOTER_RECALC_TRIGGER.privateExportEnvSet, recalculatePipedText);
            eventService.on(WIDGET_MANAGER_EVENTS.CUSTOM_METRICS_CHANGED, recalculatePipedText);
            eventService.on(EVENTS.REPORT_LANGUAGE_CHANGED, recalculatePipedText);
            function recalculatePipedText() {
                if (env.get(environment_1.ENV_VARS.FEATURES)[feature_flipper_1.FEATURES.HEADER_FOOTER_PIPED_TEXT]) {
                    var headerFooterLayout = headerFooterService.getProperties();
                    setHeaderFooterData(headerFooterLayout, HEADER);
                    setHeaderFooterData(headerFooterLayout, FOOTER);
                    return $q.all([
                        updatePipedTextHeaderFooter(HEADER, headerFooterLayout),
                        updatePipedTextHeaderFooter(FOOTER, headerFooterLayout)
                    ]);
                }
                else {
                    return $q.when();
                }
            }
            /**
             * Converts the quillObjectHTML string to quill delta.
             * This will only be used with the dynamic translated attribute quillObjectHtml.
             */
            function _convertQuillHtmlToQuillDelta(html) {
                var Quill = window.Quill;
                var editor = new Quill('#pr-custom-header-footer-hidden', {
                    modules: {
                        clipboard: {
                            matchers: [
                                ['.piped-text-highlight', quillMatcher.quillMatcherForPipedText]
                            ]
                        }
                    }
                });
                // Casting html as any to avoid an issue with typescript types
                return editor.clipboard.convert(html);
            }
            /**
             * Reads translations from the header footer definition on the context meta by
             * deserializing the saved quill HTML if it exists.
             * Then computes fresh values for piped text objects and re-renders the HTML.
             */
            function updatePipedTextHeaderFooter(headerFooter, headerFooterLayout) {
                // Existing reports with headers/footers will not have a quillObjectHtml defined if they
                // haven't saved the header or footer yet. (The quillObjectHtml is only added on save).
                // Therefore, we should default to using the existing quillObject.
                var quillObject;
                // @ts-ignore
                if (!headerFooterLayout[headerFooter].quillObjectHtml) {
                    // @ts-ignore
                    quillObject = headerFooterLayout[headerFooter].quillObject;
                }
                else {
                    // @ts-ignore
                    quillObject = _convertQuillHtmlToQuillDelta(headerFooterLayout[headerFooter].quillObjectHtml);
                }
                return dynamicValue.fetchPipedTextValue((quillObject === null || quillObject === void 0 ? void 0 : quillObject.ops) || []).then(function (newContent) {
                    // Update the header/footer properties on the context meta
                    var newHeaderFooterQuill = { ops: [] };
                    newHeaderFooterQuill.ops = newContent;
                    headerFooterOptionsService.setContents(headerFooter, newHeaderFooterQuill);
                    // @ts-ignore
                    var headerFooterData = headerFooterLayout[headerFooter];
                    // Replace current quillObject with newly translated quill object with freshly fetched piped text values
                    headerFooterData.quillObject = newHeaderFooterQuill;
                    // Create the HTML based off the updated quill from above
                    headerFooterData.html = pageHeaderFooterGenerator.getHeaderFooterHTML(headerFooterData);
                    headerFooterService.updateHeaderOrFooter(headerFooter, headerFooterLayout);
                });
            }
            function setHeaderFooterData(headerFooterLayout, headerFooter) {
                // @ts-ignore
                var headerFooterData = headerFooterLayout[headerFooter];
                var headerFooterQuill = headerFooterData.quillObject;
                var defaultQuillDelta = headerFooterOptionsService.getContents(headerFooter);
                if (headerFooterQuill !== defaultQuillDelta) {
                    headerFooterOptionsService.setContents(headerFooter, headerFooterQuill);
                }
            }
            return {
                recalculatePipedText: recalculatePipedText,
                setHeaderFooterData: setHeaderFooterData
            };
        }
    ]);
})(angular_1.default.module('qualtrics.pr'));
